
import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import About from "../pages/about/page";
import WoodMold from "../pages/woodmold/page";
import Laser from "../pages/laser/page";
import Portfolio from "../pages/portfolio/page";
import Quote from "../pages/quote/page";
import Location from "../pages/location/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/about",
    element: <About />,
  },
  {
    path: "/wood",
    element: <WoodMold />,
  },
  {
    path: "/woodmold",
    element: <WoodMold />,
  },
  {
    path: "/laser",
    element: <Laser />,
  },
  {
    path: "/portfolio",
    element: <Portfolio />,
  },
  {
    path: "/quote",
    element: <Quote />,
  },
  {
    path: "/location",
    element: <Location />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
